import { RepoList } from '@/components/RepoList/RepoList'
import type { FunctionalComponent } from 'preact'

export const HomePage: FunctionalComponent<{
  path?: string
}> = () => {
  return <RepoList />
}
